import React from 'react'
import Header from '../component/Header/Header'
import HomeHero from '../component/HomeHero/HomeHero'
import Footer from '../component/Footer/Footer'
import HomeProgram from '../component/HomeProgram/HomeProgram'
import TeamCards from '../component/TeamCards/TeamCards'
import { Helmet } from 'react-helmet'

const teamData1 = [
    {
        id:1,
        img:"/images/team/1.png",
        name:"Dr. Fabio Varlese (Founder)",
        rank:"MD, MSc, FRCPC",
        para:'Geriatric / Internal Medicine'
    },
    {
        id:2,
         img:"/images/team/2.png",
        name:"Dr. Giuseppe Papia",
        rank:"MD, MSc, FRCSC",
        para:'Vascular / General Surgery'
    },
    {
        id:3,
         img:"/images/team/3.png",
        name:"Dr. Diego Delgado",
        rank:"MD, MSc, FRCPC",
        para:'Cardiology / Cardiac Transplantation'
    },
    {
        id:4,
         img:"/images/team/4.png",
        name:"Dr. Marcus Bernardini",
        rank:"MD, MSc, FRCSC",
        para:'Gynecologic Oncology'
    },
    // {
    //     id:5,
    //      img:"/images/team/5.png",
    //     name:"Dr. Karim Ladha",
    //     rank:"MD, MSc, FRCPC",
    //     para:'Anesthesia / Pain Management'
    // },
    {
        id:6,
         img:"/images/team/6.png",
        name:"Dr. Giuseppe Costa",
        rank:"MD, FRCSC",
        para:'Orthopaedic Surgery'
    },
    {
        id:7,
         img:"/images/team/7.png",
        name:"Dr. Leora Lewittes",
        rank:"MD, FCFP, BSc, MHSc",
        para:'High Risk Breast Screening / Preventive Health'
    },
    {
        id:8,
        // img:"https://www.utcardiacsurgery.com/templates/yootheme/cache/gbisleri-58f69b9b.webp",
        
         img:"/images/team/8.png",
        name:"Dr. Gianluigi Bisleri",
        rank:"MD, FRCSC",
        para:'Minimally Invasive Cardiac Surgery'
    },
    {
        id:9,
         img:"/images/team/9.png",
        name:"Dr. Tony Finelli",
        rank:"MD, MSc, FRCSC",
        para:'Urologic Oncology'
    },
    {
        id:10,
         img:"/images/team/10.png",
        name:"Dr. Wilfred Tam",
        rank:"MD, FRCSC",
        para:''
    },
    {
        id:11,
         img:"/images/team/11.png",
        name:"Dr. Dean Elterman",
        rank:"MD, MSc, FRCSC",
        // para:'Urology / Men’s Health'
        para:'Urology'
    },
    // {
    //     id:12,
    //     img:"/images/creatives/team-card-img.png",
    //     name:"Dr. Lily Wang",
    //     rank:"",
    //     para:''
    // },
    {
        id:13,
         img:"/images/team/12.png",
        name:"Dr. Joseph Fiorellino",
        rank:"MD, FCFP, BSc, MHSc",
        para:'Anesthesiology'
    },
    {
        id:14,
         img:"/images/team/13.png",
        name:"Dr. Dave Sussman",
        rank:"MD, FRCPC",
        para:'Anesthesiology / Pain Management'
    },
    // {
    //     id:15,
    //      img:"/images/team/14.png",
    //     name:"Dr. Zane Gallinger",
    //     rank:"MD, MSc, FRCPC",
    //     para:'Gastroenterology'
    // },
    {
        id:16,
         img:"/images/team/15.png",
        name:"Dr. Amandeep S. Rai",
        rank:"MD, FRCSC",
        para:'Ophthalmology'
    },
    // {
    //     id:17,
    //     img:"/images/creatives/team-card-img.png",
    //     name:"Dr. Hamza Jalal",
    //     rank:"",
    //     para:''
    // },
    {
        id:18,
        img:"/images/creatives/team-card-img.png",
        name:"Dr. Brian Gilbert",
        rank:"",
        para:''
    },
    {
        id:19,
        img:"/images/creatives/team-card-img.png",
        name:"Dr. Carol Ott",
        rank:"",
        para:''
    },
    {
        id:35,
        img:"/images/team/35.jpeg",
        name:"Dr. Elysia Grose",
        rank:"MD, FRCSC",
        para:'Otolaryngologist'
    },
    
]
// const teamData1 = [
//     {
//         img:"/images/creatives/team-card-img-1.png",
//         name:"Dr. Fabio Varlese",
//         rank:"Md, FCFCF",
//         para:'Internal Medicine, Geriatric Medicine'
//     },
//     {
//         img:"/images/creatives/team-card-img-2.png",
//         name:"Dr. Giuseppe Papia",
//         rank:"MD, MSc, FRCSC, FRSCS",
//         para:'Cardiac & Vascular Surgery, Critical Care'
//     },
//     {
//         img:"/images/creatives/team-card-img-3.png",
//         name:"Dr. Diego Delgado",
//         rank:"Md, FCFCF",
//         para:'Heart Failure, Transplantation'
//     },
//     {
//         img:"/images/creatives/team-card-img-4.png",
//         name:"Dr. Marcus Bernardini",
//         rank:"MSc, MD, FRCPC",
//         para:'Gynecologic Oncology'
//     },
//     {
//         img:"/images/creatives/team-card-img-1.png",
//         name:"Dr. Karim Ladha",
//         rank:"MD, MSc, FRCPC",
//         para:'Anesthesiology & Research'
//     },
//     {
//         img:"/images/creatives/team-card-img-1.png",
//         name:"Dr. Giuseppe Costa",
//         rank:"MD, FRCSC",
//         para:'Orthopaedic & Sports Medicine'
//     },
//     {
//         img:"/images/creatives/team-card-img-1.png",
//         name:"Dr. Carolina Landolt",
//         rank:"MD",
//         para:'Rehumathology'
//     },
//     {
//         img:"/images/creatives/team-card-img-1.png",
//         name:"Dr. Joseph Fiorellino",
//         rank:"MD, MSc, FRCPC",
//         para:'Anesthesiology'
//     },
//     {
//         img:"/images/creatives/team-card-img-1.png",
//         name:"Dr. Leora Lewittes",
//         rank:"MD, FCFP, BSc, MHSc",
//         para:'High-risk Breast Screening'
//     },
// ]

const teamCard2 = [
    {
        id:20,
        img:"/images/creatives/team-card-img.png",
        name:"Artium Radzichovski, NP",
        rank:"NP, MN, PHC-NP",
        para:''
    },
    {
        id:21,
        img:"/images/team/34.jpeg",
        name:"Kimberley Amos, MD",
        rank:"MD",
        para:''
    },
    {
        id:36,
        img:"/images/creatives/team-card-img.png",
        name:"Quinne Mason, NP",
        rank:"NP",
        para:''
    },
]

const teamCard3 = [
    {
        id:22,
         img:"/images/team/20.png",
        name:"Dr. Akram Keymanesh",
        rank:"",
        para:'Audiologist'
    },
    {
        id:23,
         img:"/images/team/21.jpg",
        name:"Dr. Asli Ozbek Figueroa Orta",
        rank:"MD (Turkey), ND",
        para:'Naturopathic Medicine / Ophthalmology (Turkey)'
    },
    {
        id:24,
         img:"/images/team/22.png",
        name:"Dr. Thanu Jey",
         rank:"",
        para:'Chiropractor'
    },
    {
        id:25,
         img:"/images/team/23.png",
        name:"Dr. Sukhmeet Chohan",
        rank:"",
        para:'Chiropractor'
    },
    {
        id:26,
         img:"/images/team/24.png",
        name:"TS Simmons",
        rank:"RPT, CBT",
        para:'Social Work'
    },
    {
        id:27,
         img:"/images/team/25.png",
        name:"Kayo da Souza",
         rank:"",
        para:'Physiotherapy'
    },
    {
        id:28,
         img:"/images/team/26.png",
        name:"Cecilia Fung",
         rank:"",
        para:''
    },
    
]

const teamCard4 =[
    {
        id:29,
        img:"/images/creatives/team-card-img.png",
        name:"Kadine Clarke",
        rank:"",
        para:'Admin'
    },
    {
        id:30,
        img:"/images/creatives/team-card-img.png",
        name:"Jaclyn Adamathwhite",
        rank:"",
        para:'Admin'
    },
    // {
    //     id:31,
    //     img:"/images/creatives/team-card-img.png",
    //     name:"Fatana Shah",
    //     rank:"",
    //     para:'Admin'
    // },
    {
        id:32,
        img:"/images/creatives/team-card-img.png",
        name:"Alessandro Castellan",
        rank:"",
        para:'Admin'
    },
    {
        id:33,
         img:"/images/team/33.png",
        name:"Dr. Emmanuel Lereno",
        rank:"",
        para:'Admin'
    },
]

export const getTeamData = (memberId)=>{
    const firstArResult = teamData1.filter((teamCard)=>(teamCard?.id == memberId))
    if(firstArResult[0]){
        return firstArResult[0]
    }
    const secondArResult = teamCard2.filter((teamCard)=>(teamCard?.id == memberId))
    if(secondArResult[0]){
        return secondArResult[0]
    }
    const thirdArResult = teamCard3.filter((teamCard)=>(teamCard?.id == memberId))
    if(thirdArResult[0]){
        return thirdArResult[0]
    }
    const fourthArResult = teamCard4.filter((teamCard)=>(teamCard?.id == memberId))
    if(fourthArResult[0]){
        return fourthArResult[0]
    }
}

function Team() {
  return (
    <div style={{backgroundColor:"#FAF6ED"}}>
        <Helmet>
        <title>
        Meet Our Medical Team | The Toronto Clinic
        </title>
        {/* <meta name="keywords" 
        content=""
        ></meta> */}
        <link
          rel="canonical"
          href="https://thetorontoclinic.com/team"
        />
        <meta
          name="description"
          content="Meet the team of specialists, physicians, and healthcare professionals behind The Toronto Clinic’s personalized, preventative, and world-class care."
        ></meta>
       
      </Helmet>
        <Header/>
        <HomeHero
            heading='It takes a '
            spanHeading="team"
            afterSpanHeading=" to deliver exceptional care"
            content='Through the years, The Toronto Clinic has carefully attracted in their network the best minds in the clinical world, so that you can benefit from their valuable support. '
            textCtaBlack={true}
            headingBlack={true}
            showLogo={false}
            plainCta={false}
            bgImage={"/images/creatives/gradient-bg-3.png"}
            fullWidth={true}
            textCenter={true}
            largePara={false}
            btn={false}
        />

        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"contain",backgroundRepeat:"no-repeat"}}>
        <div style={{backgroundImage:"url(/images/creatives/gradient-bg-3.png)",backgroundPosition:"center",backgroundSize:"contain",backgroundRepeat:"no-repeat"}}>
        <TeamCards
            title="Specialists"
            cardData={teamData1}
            />
        </div>
        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"contain",backgroundRepeat:"no-repeat"}}>
        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"bottom",backgroundSize:"contain",backgroundRepeat:"no-repeat"}}>
        <div style={{backgroundImage:"url(/images/creatives/gradient-bg-3.png)",backgroundPosition:"center",backgroundSize:"contain",backgroundRepeat:"no-repeat"}}>
            <TeamCards
                title="Primary care"
                cardData={teamCard2}
            />
            <TeamCards
                title="Allied Health"
                cardData={teamCard3}
            />
        </div>
        </div>
        </div>
        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"center",backgroundSize:"contain",backgroundRepeat:"no-repeat"}}>
            <TeamCards
                title="Administrators & Support"
                cardData={teamCard4}
            />
        </div>
        </div>

        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"center",backgroundSize:"contain",backgroundRepeat:"no-repeat"}}>
            <HomeProgram
            mainCardHeading="The path to health begins here, take the first step"
            mainCardPara="At The Toronto Clinic, we redefine healthcare with a proactive, deeply personalized approach. Designed to support your longevity and well-being, our program ensures you stay at your peak: healthy, confident, and in control."
            btnText="Explore membership"
            btnRef="/membership"
            mainCardImg={"/images/creatives/membership-text-2.png"}
            showList={false}
            leftBottomBorderRadius={true}
            backgroundPlain={true}
            />
            <Footer
            newsletterSection={false}
            />
        </div>
    </div>
  )
}
export default Team